<template>
    <div class="l-listings">
        <div class="container">
            <div class="e-searchtop" v-if="showSearchResultsHeading && filters.keywords">
                <h1>Showing results for: {{filters.keywords}}</h1>
            </div>
            <div class="sidebar-grid">
                <div class="m-filters sidebar-grid__filters">
                    <h2 class="text-scale-base text-dark-blue leading-base">Refine results</h2>
                    <search-filters></search-filters>
                    <!-- <related-authors v-if="isAuthorPage"></related-authors>
                    <related-topics v-if="isTopicPage"></related-topics> -->
                    <!-- <div class="myhie-cta flow" v-if="isLoggedIn && isTopicPage && topicTagId > 0">
                        <h2 class="text-scale-small text-dark-blue">Enjoying these articles?</h2>
                        <p>Add posts about {{topicTagName}} to your MyHIE dashboard</p>
                        <a href="#" class="btn" :topic-tag-id="topicTagId" v-on:click.prevent="addBlogTopicTag" :disabled="isAdded">
                            {{isAdded ? 'Topic added to MyHIE' : 'Add topic to MyHIE'}}
                        </a>
                    </div>
                    <div class="myhie-cta flow" v-if="!isLoggedIn">
                        <h2 class="text-scale-small text-dark-blue">Enjoying these articles?</h2>
                        <p>
                            Make your life easier with a MyHIE account. Save posts to read later and
                            get updates on the topics you are interested in straight to your MyHIE dashboard.
                        </p>
                        <div class="flow">
                            <a href="/myhie/" v-if="!isLoggedIn">Find out more about MyHIE</a>
                            <a href="/account/register-for-myhie/" class="btn">Create a MyHIE account</a>
                        </div>
                    </div> -->
                </div>
                <div class="sidebar-grid__results">
                    <div v-if="isLoading" class="loading-spinner">
                        <div class="spinner"></div>
                    </div>
                    <div v-else>
                        <div v-if="resultCount === 0" class="e-noresults">
                            <p class="text-scale-small">
                                <strong>Sorry, there are no results that currently match your selection, please refine your search.</strong>
                            </p>
                        </div>
                        <div v-else class="flow-m">
                            <div>
                                <h2 class="text-scale-base text-colour-lightest leading-base">Showing {{resultsLoaded}} of {{resultCount}} results</h2>
                                <div id="js-results-count" class="js-results-count" aria-live="assertive">
                                    <span class="visually-hidden">
                                        {{resultCount}} results
                                        sorted by Updated (newest)
                                    </span>
                                </div>
                            </div>
                            <div class="items blog-results results-list">
                                <blog-list-item class="result-card" v-for="searchResult in searchResults" :key="searchResult.Id" :result-item="searchResult" :hideImage="true"></blog-list-item>
                            </div>
                            <div>
                                <p class="text-colour-lightest"><strong>Showing {{resultsLoaded}} of {{resultCount}} results</strong></p>
                                <search-pager v-if="moreResultsAvailable"></search-pager>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Axios from 'axios'
    
    import BlogListItem from '@/components/BlogSearch/blog-list-item'
    //import FeaturedBlogItem from '@/components/BlogSearch/featured-blog-item'
    // import RelatedAuthors from '@/components/BlogSearch/related-authors'
    // import RelatedTopics from '@/components/BlogSearch/related-topics'
    import SearchFilters from '@/components/SiteSearch/search-filters'
    import SearchPager from '@/components/SiteSearch/search-pager'

    import { globalMixin } from '@/mixins/globalMixin.js'
    import { searchMixin } from '@/mixins/searchMixin.js'

    export default {
        components: {
            BlogListItem,
            //FeaturedBlogItem,
            // RelatedAuthors,
            // RelatedTopics,
            SearchFilters,
            SearchPager
        },

        computed: {
            isLoading() {
                return this.$store.getters.isLoading
            },

            filters: {
                get() {
                    return this.$store.state.search.filters
                },
                set() { }
            },

            isLoggedIn: function () {
                return isLoggedIn
            },

            moreResultsAvailable: function () {
                return this.$store.getters.moreResultsAvailable
            },

            resultsLoaded: function () {
                return this.$store.state.search.resultsLoaded
            },

            searchResults: function () {
                return this.$store.state.search.results
            },

            resultCount: function () {
                return this.$store.state.search.resultCount
            }
        },

        created: function () {
            this.$eventHub.$on('search-filtersChanged', this.onFiltersChanged)
            this.$eventHub.$on('search-pageChanged', this.onPageChanged)

            this.$store.dispatch('updateSearchFilter', { key: 'page', value: 1 })
            this.$store.dispatch('updateSearchFilter', { key: 'showAllResults', value: false })

            this.search(true)
        },

        data() {
            return {
                loading: false,
                isAdded: false,
                toggling: false,
                searchApiUrl: '/umbraco/api/SearchApi/Search'
            }
        },

        methods: {
            onFiltersChanged: function () {
                this.search(true)
            },

            onPageChanged: function () {
                this.search()
            },

            addBlogTopicTag: function () {
                const vm = this
                vm.toggling = true

                const updateProfile = function () {
                    return Axios.get('/umbraco/api/MemberProfileApi/AddBlogTopicTag', { params: { blogTopicTagId: vm.topicTagId } })
                }

                Axios.all([updateProfile()])
                    .then(Axios.spread(function (response) {

                        if (response) {
                            vm.isAdded = response.data
                        }
                        vm.toggling = false
                    }))
                    .catch(() => {
                        vm.toggling = false
                    })
            }
        },

        mixins: [globalMixin, searchMixin],

        props: {
            featuredBlogId: {
                default: 0,
                type: Number
            },

            locationLink: {
                default: null,
                type: String
            },

            isAuthorPage: {
                default: false,
                type: Boolean
            },

            isTopicPage: {
                default: false,
                type: Boolean
            },

            showSearchResultsHeading: {
                default: false,
                type: Boolean
            },

            topicTagId: {
                default: 0,
                type: Number
            },

            topicTagName: {
                default: null,
                type: String
            }
        }
    }
</script>